import { render, staticRenderFns } from "./OperatorRecordForm.vue?vue&type=template&id=872aee54&scoped=true&"
import script from "./OperatorRecordForm.vue?vue&type=script&lang=js&"
export * from "./OperatorRecordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872aee54",
  null
  
)

export default component.exports